module.exports = __webpack_public_path__ + "static/media/patreon.7ce49116.svg";